<template>
	<div>
    <draggable v-model="stateEpics" class="dragArea" :options="{group:'epics-rows', ghostClass: 'ghost-class', handle: '.dragEpic'}" @update="epicsReordered">
    	<epic-item v-for="(epic, index) in epics" :key="epic.id" :index="index" :initial-epic="epic"></epic-item>
    </draggable>

    <input v-model="newEpic.title" type="text" class="add-epic form-control" placeholder="Add Epic" @keyup.enter.prevent="handleCreateEpic" />

    <story-history-drawer ref="storyHistoryDrawer"></story-history-drawer>
  </div>
  
</template>

<script>
  
  import { mapState, mapActions } from 'vuex'
  import draggable from 'vuedraggable'
  import EpicItem from 'components/epics/Epic.vue'
  import StoryHistoryDrawer from 'components/user-stories/StoryHistoryDrawer.vue'
  import { http } from 'utils'

  import Story from './../../models/story.js'
  import Epic from './../../models/epic.js'

  export default {

    components: {
      draggable,
      EpicItem,
      StoryHistoryDrawer
    },

    data () {
      return {
        newEpic: new Epic(),
        newUserStory: new Story(),
      }
    },

    computed: {
      ...mapState('yodizproject', {
                project: 'single'
      }),
      ...mapState('epics', ['epics']),

      stateEpics: {
        get () {
          return this.epics
        },

        set (value) {
          this.setEpics(value)
        }
      },
    },

    mounted () {
      var that = this

      this.$bus.$on('delete-epic', function (id) {
        that.deleteEpic(id);
      })

      this.$bus.$on('us-history', function ({ storyId }) {
        that.$refs.storyHistoryDrawer.open({ storyId })
      })
    },

    methods: {
      ...mapActions('epics', ['addEpic', 'reorderEpics', 'setEpics']),

      epicOrderArray () {
        var epicOrderArray = []
        
        for (var i = 0; i < this.epics.length; i++) {
          var epic = this.epics[i]
          
          epicOrderArray.push({id: epic.id})
        }

        return {
          epics: epicOrderArray
        }
      },

      handleCreateEpic () {
        var that = this

        this.addEpic({
          id: this.project.user_story_document_id,
          payload: this.newEpic
        }).then((response) => {
          //reset the form data
          this.newEpic = new Epic()

          //open the new epic!!

        }).catch((response) => {

        })
      },

      deleteEpic(id) {
        var epicIndex = this.epics.findIndex(x => x.id === id)

        if (epicIndex >= 0) {
          this.epics.splice(epicIndex, 1)
          this.epicsReordered();
        }
      },

      saveEpicOrder () {
        var that = this

        return this.reorderEpics({
          id: this.project.user_story_document_id,
          payload: this.epicOrderArray()
        })
      },

      epicsReordered (event) {
        
        this.saveEpicOrder()
      },

      collapseAll () {
        this.$bus.$emit('collapse-all-epics', 1)
      }
    }

  }

</script>
